import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {LeftpanelComponent} from './leftpanel/leftpanel.component';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DevexListenerService {

  @Output() devexListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.devexListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        });
  }
}
